import { Box, Text } from '@chakra-ui/react'

export const TitleHeader = ({ title }) => (
  <Box w="100%" h="44px" bg="white" borderBottom="1px" borderColor="divider.light" display="flex" alignItems="center" justifyContent="center">
    <Text fontSize="lg" fontWeight="600" lineHeight="22px">
      {title}
    </Text>
  </Box>
)
